import { render } from "./WeHaveOffer.vue?vue&type=template&id=65f97866"
import script from "./WeHaveOffer.vue?vue&type=script&lang=js"
export * from "./WeHaveOffer.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__